import { sortText } from "../../../js/utility.js";
export default {
    staffs(state) {
        return sortText(state.staffs, "username");
    },
};